import { render, staticRenderFns } from "./TransportInfo.vue?vue&type=template&id=53a594b1"
import script from "./TransportInfo.vue?vue&type=script&lang=js"
export * from "./TransportInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports